import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "22",
  fill: "none",
  viewBox: "0 0 28 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.227 16.761v2.406h6.137V21.5H6.636v-2.333h6.137V16.76c-2.373-.284-4.555-1.382-6.137-3.087S4.182 9.774 4.182 7.5v-7h19.636v7c0 2.273-.873 4.469-2.454 6.174s-3.764 2.803-6.137 3.087M.5 2.833h2.455V7.5H.5zm24.546 0H27.5V7.5h-2.454z"
    }, null, -1)
  ])))
}
export default { render: render }